import React from 'react';
import { Logo1 } from '../../Assests/Assests';
import './FloatingLogo.css';

/**
 * A small R, always spinning, pinned to the top right of every page.
 *
 * This used to be a 90px logo sitting in the middle of the hero that could be
 * dragged around with a mouse or a finger, and whose spin speed tracked scroll
 * velocity — three scroll listeners, a requestAnimationFrame loop and two drag
 * handlers, all running on every page. Marwin asked for the simple version:
 * one small mark, same place, every page.
 *
 * Position comes from --riymay-header rather than the old hardcoded 130px, so
 * it stays clear of the navbar when the header height changes.
 */
const FloatingLogo = () => (
  <div className="floating-logo" aria-hidden="true">
    <img src={Logo1} alt="" className="floating-logo__img" draggable={false} />
  </div>
);

export default FloatingLogo;
